// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 2H2V22H13.2322C12.7644 21.1025 12.5 20.0821 12.5 19C12.5 17.0997 13.3155 15.3899 14.6156 14.2013L9 8.58579L4 13.5858V4H20V12.5764C20.7113 12.6863 21.3845 12.9114 22 13.2322V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M16 5.25C14.4812 5.25 13.25 6.48122 13.25 8C13.25 9.51878 14.4812 10.75 16 10.75C17.5188 10.75 18.75 9.51878 18.75 8C18.75 6.48122 17.5188 5.25 16 5.25Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21.8289 23.2426L23.2431 21.8284L20.4147 19L23.2431 16.1715L21.8289 14.7573L19.0005 17.5857L16.172 14.7573L14.7578 16.1715L17.5862 19L14.7578 21.8284L16.172 23.2426L19.0005 20.4142L21.8289 23.2426Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-image-error-filled')
export default class ImageErrorFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'image-error-filled',
    }
  }
}
